import { render, staticRenderFns } from "./card-icon-top.vue?vue&type=template&id=7bb56b59&"
import script from "./card-icon-top.vue?vue&type=script&lang=js&"
export * from "./card-icon-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports